import { render } from "./LastExamAttempts.vue?vue&type=template&id=ba8a635a&scoped=true"
import script from "./LastExamAttempts.vue?vue&type=script&lang=js"
export * from "./LastExamAttempts.vue?vue&type=script&lang=js"

import "./LastExamAttempts.vue?vue&type=style&index=0&id=ba8a635a&scoped=true&lang=css"

import exportComponent from "/Users/admin/dev/claire/web/orca-analytics.web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba8a635a"]])

export default __exports__